import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Organization } from 'src/app/models/um/organization';
import {serviceConstants } from 'src/app/constants/service.constants';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-um-organization-password-policy-view-modal',
  templateUrl: './um-organization-password-policy-view-modal.component.html',
  styleUrls: ['./um-organization-password-policy-view-modal.component.scss']
})
export class UmOrganizationPasswordPolicyViewModalComponent implements OnInit {
@Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  organization: Organization;
  orgForm: UntypedFormGroup;

  constructor(
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
  ) {
  }

  ngOnInit() {
    this.organization = new Organization();
    this.setForm(this.organization);
    if (this.Content.content && this.Content.content.id) { // Edit mode
      this.summaryService.getSummaryData(serviceConstants.apiURL + 'api/organization/getorganizationbyid/' + this.Content.content.id).subscribe((result) => {
        this.organization = result;
        this.setForm(this.organization);
        if (this.Content.heading === 'View')
          this.orgForm.disable();
      });
    }
  }

  save() {
    this.summaryService.Insert(serviceConstants.apiURL + 'api/organization/UpdateOrganization', this.getForm()).subscribe(result => {
      
      this.modalRef.close();
    })
  }

  private setForm(result: Organization): void {

    this.orgForm = new UntypedFormGroup({
      ADDRESS1: new UntypedFormControl(result.ADDRESS1),
      ADDRESS2: new UntypedFormControl(result.ADDRESS2),
      CITY: new UntypedFormControl(result.CITY),
      CODE: new UntypedFormControl(result.CODE),
      COUNTRY: new UntypedFormControl(result.COUNTRY),
      CREATED_BY: new UntypedFormControl(result.CREATED_BY),
      CREATED_DATE: new UntypedFormControl(result.CREATED_DATE),
      DEFAULT_CURRENCY_ID: new UntypedFormControl(result.DEFAULT_CURRENCY_ID),
      DONT_ALLOW_DICTIONARY_WORDS: new UntypedFormControl(result.DONT_ALLOW_DICTIONARY_WORDS),
      EAP: new UntypedFormControl(result.EAP),
      EMAIL: new UntypedFormControl(result.EMAIL),
      FAX_NO: new UntypedFormControl(result.FAX_NO),
      FAX_NO_EXT: new UntypedFormControl(result.FAX_NO_EXT),
      GRANTS: new UntypedFormControl(result.GRANTS),
      ID: new UntypedFormControl(result.ID),
      IST: new UntypedFormControl(result.IST),
      IS_NUM_MANDATE_IN_PWD: new UntypedFormControl(result.IS_NUM_MANDATE_IN_PWD),
      IS_PASSWORD_POLICY_APPLICABLE: new UntypedFormControl(result.IS_PASSWORD_POLICY_APPLICABLE),
      IS_SPC_CHAR_MANDATE_IN_PWD: new UntypedFormControl(result.IS_SPC_CHAR_MANDATE_IN_PWD),
      IS_UPPER_MANDATE_IN_PWD: new UntypedFormControl(result.IS_UPPER_MANDATE_IN_PWD),
      LANGUAGE_ID: new UntypedFormControl(result.LANGUAGE_ID),
      LAST_UPDATED_BY: new UntypedFormControl(result.LAST_UPDATED_BY),
      LAST_UPDATED_DATE: new UntypedFormControl(result.LAST_UPDATED_DATE),
      LICENCE_END_DATE: new UntypedFormControl(result.LICENCE_END_DATE),
      LOGIN_ATTEMPTS_TO_DISABLE: new UntypedFormControl(result.LOGIN_ATTEMPTS_TO_DISABLE),
      LOGO: new UntypedFormControl(result.LOGO),
      MAIN_HEADER: new UntypedFormControl(result.MAIN_HEADER),
      MIN_PASSWORD_LENGTH: new UntypedFormControl(result.MIN_PASSWORD_LENGTH),
      NAME: new UntypedFormControl(result.NAME),
      NO_OF_PREV_PASS_MATCH_NEW_PWD: new UntypedFormControl(result.NO_OF_PREV_PASS_MATCH_NEW_PWD),
      OBS_CODE: new UntypedFormControl(result.OBS_CODE),
      ORGANIZATION_ID: new UntypedFormControl(result.ORGANIZATION_ID),
      PASSWORD_EXPIRY_DATE: new UntypedFormControl(result.PASSWORD_EXPIRY_DATE),
      PHONE_NO: new UntypedFormControl(result.PHONE_NO),
      PHONE_NO_EXT: new UntypedFormControl(result.PHONE_NO_EXT),
      RECORD_STATE: new UntypedFormControl(result.RECORD_STATE),
      STATE: new UntypedFormControl(result.STATE),
      SUB_HEADER: new UntypedFormControl(result.SUB_HEADER),
      WEB_SITE: new UntypedFormControl(result.WEB_SITE),
      ZIP: new UntypedFormControl(result.ZIP),
      CME_CURRENCY_ID: new UntypedFormControl(result.CME_CURRENCY_ID),
      CHARITABLE_CURRENCY_ID: new UntypedFormControl(result.CHARITABLE_CURRENCY_ID),
      SPONSERSHIP_CURRENCY_ID: new UntypedFormControl(result.SPONSERSHIP_CURRENCY_ID),
      AUTHTYPE: new UntypedFormControl(result.AUTHTYPE)
    });
  }

  private getForm(): Organization {

    const formModel = this.orgForm.value;

    let org = new Organization();
    org = {
      ADDRESS1: formModel.ADDRESS1 || '',
      ADDRESS2: formModel.ADDRESS2 || '',
      CITY: formModel.CITY || '',
      CODE: formModel.CODE || '',
      COUNTRY: formModel.COUNTRY || '',
      CREATED_BY: null,
      CREATED_DATE: '2020-08-11',
      DEFAULT_CURRENCY_ID: formModel.DEFAULT_CURRENCY_ID,
      DONT_ALLOW_DICTIONARY_WORDS: null,
      EAP: Boolean(formModel.EAP) || false,
      EMAIL: formModel.EMAIL || '',
      FAX_NO: formModel.FAX_NO || '',
      FAX_NO_EXT: Number(formModel.FAX_NO_EXT) || null,
      GRANTS: Boolean(formModel.GRANTS) || false,
      ID: formModel.ID || '',
      IST: Boolean(formModel.IST) || false,
      IS_NUM_MANDATE_IN_PWD: formModel.IS_NUM_MANDATE_IN_PWD,
      IS_PASSWORD_POLICY_APPLICABLE: formModel.IS_PASSWORD_POLICY_APPLICABLE,
      IS_SPC_CHAR_MANDATE_IN_PWD: formModel.IS_SPC_CHAR_MANDATE_IN_PWD,
      IS_UPPER_MANDATE_IN_PWD: formModel.IS_UPPER_MANDATE_IN_PWD,
      LANGUAGE_ID: null,
      LAST_UPDATED_BY: null,
      LAST_UPDATED_DATE: '2020-08-11',
      LICENCE_END_DATE: null,
      LICENCE_END_DATES: null,
      LICENCE_END_DATEO: null,
      LOGIN_ATTEMPTS_TO_DISABLE: Number(formModel.LOGIN_ATTEMPTS_TO_DISABLE),
      LOGO: formModel.LOGO || '',
      MAIN_HEADER: formModel.MAIN_HEADER || '',
      MIN_PASSWORD_LENGTH: Number(formModel.MIN_PASSWORD_LENGTH)|| null,
      NAME: formModel.NAME || '',
      NO_OF_PREV_PASS_MATCH_NEW_PWD: Number(formModel.NO_OF_PREV_PASS_MATCH_NEW_PWD),
      OBS_CODE: null,
      ORGANIZATION_ID: null,
      PASSWORD_EXPIRY_DATE: Number(formModel.PASSWORD_EXPIRY_DATE),
      PHONE_NO: formModel.PHONE_NO || '',
      PHONE_NO_EXT: Number(formModel.PHONE_NO_EXT) || null,
      RECORD_STATE: Number(formModel.RECORD_STATE) || 0,
      STATE: formModel.STATE || '',
      SUB_HEADER: formModel.SUB_HEADER || '',
      WEB_SITE: formModel.WEB_SITE || '',
      ZIP: formModel.ZIP || '',
      IST_CURRENCY_ID: formModel.IST_CURRENCY_ID || '',
      EAP_CURRENCY_ID: formModel.EAP_CURRENCY_ID || '',
      CME_CURRENCY_ID: formModel.CME_CURRENCY_ID || '',
      CHARITABLE_CURRENCY_ID: formModel.CHARITABLE_CURRENCY_ID || '',
      SPONSERSHIP_CURRENCY_ID: formModel.SPONSERSHIP_CURRENCY_ID || '',
      FILENAME: '',
      FILEID: '',
      DSFILENAME: '',
      DSFILEID: '',
      ACTIVE_USERS_LIMIT: formModel.ACTIVE_USERS_LIMIT || 0,
      SPACE_ALLOCATION_BG: formModel.SPACE_ALLOCATION_BG || 0,
      DATAPEROID_IN_YEARS: formModel.DATAPEROID_IN_YEARS || 0,
      REPRESENTATIVE_NAME: formModel.REPRESENTATIVE_NAME || '',
      REPRESENTATIVE_EMAIL: formModel.REPRESENTATIVE_EMAIL || '',
      REPRESENTATIVE_PHONE_NO: formModel.REPRESENTATIVE_PHONE_NO || '',
      REPRESENTATIVE_PHONE_NO_EXT: formModel.REPRESENTATIVE_PHONE_NO_EXT || '',
      REPRESENTATIVE_ADDRESS: formModel.REPRESENTATIVE_ADDRESS || '',
      ADMINISTRATOR_NAME: formModel.ADMINISTRATOR_NAME || '',
      ADMINISTRATOR_EMAIL: formModel.ADMINISTRATOR_EMAIL || '',
      ADMINISTRATOR_PHONE_NO: formModel.ADMINISTRATOR_PHONE_NO || '',
      ADMINISTRATOR_PHONE_NO_EXT: formModel.ADMINISTRATOR_PHONE_NO_EXT || '',
      ADMINISTRATOR_ADDRESS: formModel.ADMINISTRATOR_ADDRESS || '',
      AUTHTYPE: formModel.AUTHTYPE,
      FK_ACC_ATVY_EMAILID:"",
      FK_CORRES_EMAILID:"",
      IS_ANALYTICS_CONFIGURED: Boolean(formModel.IS_ANALYTICS_CONFIGURED) || false,
      LOGI_URL:formModel.LOGI_URL || '',
      LOGI_CLIENTID: formModel.LOGI_CLIENTID || '',
      LOGI_CLIENT_SECRET: formModel.LOGI_CLIENT_SECRET || '',
      LOGI_SUPERVISOR_USERNAME: formModel.LOGI_SUPERVISOR_USERNAME || '',
      LOGI_SUPERVISOR_PASSWORD: formModel.LOGI_SUPERVISOR_PASSWORD || '', 
      LOGI_ADMIN_USERNAME: formModel.LOGI_CLIENT_SECRET || '',
      LOGI_ADMIN_PASSWORD: formModel.LOGI_SUPERVISOR_USERNAME || '',
      LOGI_ADMIN_ACCESSTOKEN: formModel.LOGI_SUPERVISOR_PASSWORD || '',
      IS_ORG_ACCOUNT_IN_LOGI: Boolean(formModel.IS_ORG_ACCOUNT_IN_LOGI) || false,
      CANREFRESH :Boolean(formModel.CANREFRESH) || false,

      IST_DISPLAY_NAME: formModel.IST_DISPLAY_NAME || '',
      EAP_DISPLAY_NAME: formModel.EAP_DISPLAY_NAME || '',
      GRANTS_DISPLAY_NAME: formModel.GRANTS_DISPLAY_NAME || '',
      CME_DISPLAY_NAME: formModel.CME_DISPLAY_NAME || '',
      CHARITY_DISPLAY_NAME: formModel.CHARITY_DISPLAY_NAME || '',
      SPONSERSHIP_DISPLAY_NAME: formModel.SPONSERSHIP_DISPLAY_NAME || '',

      CHARITY: Boolean(formModel.CHARITY) || false,
      SPONSERSHIP: Boolean(formModel.SPONSERSHIP) || false,
      CME: Boolean(formModel.CME) || false,
      TIMEZONE:formModel.TIMEZONE || 'UTC'
    };

    return org;
  }


}
